const React = require('react');

const Container = require('./Container.jsx');
const Content = require('./Content.jsx');
const TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region V1

function SignatureV1(props) {
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }

    const data = props.data || {};
    let lineColorDate, styleDate, dateWidth;
    if (includes.Date) {
        styleDate = Utilities.Config.getStyle(data, blockProps, 'Date', { textAlign: 'right', whiteSpace: 'pre-wrap' });
        if (!Utilities.isNullOrWhitespace(blockProps.lineColorDate)) {
            lineColorDate = blockProps.lineColorDate;
        } else if (!Utilities.isNullOrWhitespace(styleDate.color)) {
            lineColorDate = styleDate.color;
        }
        if (blockProps.dateWidth) {
            dateWidth = blockProps.dateWidth;
        }
    }
    let signatureWidth = 100;
    if (dateWidth) {
        const width = parseInt(dateWidth, 10);
        if (!isNaN(width)) {
            signatureWidth -= width;
        }
    }
    const styleSignature = Utilities.Config.getStyle(data, blockProps, 'Signature', { textAlign: 'right', whiteSpace: 'pre-wrap' });
    let lineColorSignature;
    if (!Utilities.isNullOrWhitespace(blockProps.lineColorSignature)) {
        lineColorSignature = blockProps.lineColorSignature;
    } else if (!Utilities.isNullOrWhitespace(styleSignature.color)) {
        lineColorSignature = styleSignature.color;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <Content.ValueWrapperCell style={styleSignature}>{blockProps.labelTextSignature}</Content.ValueWrapperCell>
                <td style={{ borderBottom: `1px solid ${lineColorSignature}` }} width={`${signatureWidth}%`}></td>
                <td>
                    <div style={{ width: blockProps.spacing }} />
                    {props.builder && Utilities.Builder.dragOutline()}
                </td>
                {
                    includes.Date &&
                    <React.Fragment>
                        <Content.ValueWrapperCell style={styleDate}>{blockProps.labelTextDate}</Content.ValueWrapperCell>
                        <td style={{ borderBottom: `1px solid ${lineColorDate}` }} width={`${dateWidth}%`}></td>
                    </React.Fragment>
                }
            </tr>
        </Container>
    );
}

const TypeConfigV1 = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    TypeConfig.options.firstPageOnly(),
                    { display: 'Signature Properties', id: 'signatureProps', type: 'header' },
                    {
                        display: 'Display Text',
                        name: 'labelTextSignature',
                        type: 'text',
                        value: 'Signature: '
                    },
                    { type: 'spacer' },
                    ...TypeConfig.options.text({ name: 'Signature' }, {}),
                    {
                        display: 'Signature Line Color',
                        name: 'lineColorSignature',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Date Properties', id: 'dateProps', type: 'header' },
                    {
                        display: 'Display Text',
                        name: 'labelTextDate',
                        type: 'text',
                        value: 'Date: '
                    },
                    { type: 'spacer' },
                    ...TypeConfig.options.text({ name: 'Date' }, {}),
                    {
                        display: 'Date Line Color',
                        name: 'lineColorDate',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Table Properties', id: 'tableProps', type: 'header' },
                    {
                        display: 'Date Column Width (%)',
                        name: 'dateWidth',
                        type: 'text',
                        value: '40'
                    },
                    {
                        display: 'Column Spacing',
                        name: 'spacing',
                        type: 'text',
                        value: '80px'
                    }
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Date', name: 'Date', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return TypeConfig.panel.layoutStyle(); }
    }
};

// #endregion V1

// #region V2

function SignatureV2(props) {
    let label, descriptionContent, value;
    if (props.config && props.config.config) {
        const blockProps = props.config.config.Block || {};
        if (blockProps.count != '1' && props.config.config.Label) {
            const config = { ...props.config.config.Label };
            if (props.label != undefined) {
                config.design = props.label;
            }
            label = TypeConfigV2.processLineOptions(config, blockProps.displayType);
        }
        if (blockProps.count == '3' && props.config.config.Description) {
            const config = { ...props.config.config.Description };
            if (props.descriptionContent != undefined) {
                config.design = props.descriptionContent;
            }
            descriptionContent = TypeConfigV2.processLineOptions(config, blockProps.displayType);
        }
        if (props.config.config.Value) {
            const config = { ...props.config.config.Value };
            if (props.content != undefined) {
                config.design = props.content;
            }
            value = TypeConfigV2.processLineOptions(config, blockProps.displayType);
        }
    }
    return <Content.LabelValue {...props} descriptionContent={descriptionContent} formatValue={false} label={label} value={value} />
}

const TypeConfigV2 = {
    _addLineOptions: (blockConfig) => {
        const group = blockConfig.group;
        for (let i = 0; i < blockConfig.options.length; i++) {
            if (blockConfig.options[i].name != 'design') {
                continue;
            }
            blockConfig.options.splice(i + 1, 0,
                {
                    display: 'Label Spacing',
                    fullWidth: true,
                    group,
                    max: '100',
                    name: 'labelSpacing',
                    options: TypeConfig.dropdown.measurement(),
                    type: 'measurement-slider',
                    value: { "unit": "px", "value": "5" }
                },
                {
                    display: 'Line Color',
                    group,
                    name: 'lineColor',
                    type: 'color-left'
                },
                {
                    display: 'Line Width',
                    group,
                    name: 'lineWidth',
                    options: TypeConfig.dropdown.measurement(),
                    type: 'measurement',
                    value: { "unit": "px", "value": "1" }
                },
                {
                    display: 'Extend Line Below Content',
                    fullWidth: true,
                    group,
                    name: 'extendLine',
                    type: 'checkbox',
                    value: false
                }
            );
            break;
        }
        return blockConfig;
    },
    panel: {
        block: (firstPageOnly) => {
            const blockConfig = Content.TypeConfig.labelValue.panelV2.block();
            if (firstPageOnly) {
                blockConfig.options.splice(0, 0, {
                    display: 'Only Show On First Page',
                    group: blockConfig.group,
                    fullWidth: true,
                    name: 'renderOnlyFirst',
                    type: 'checkbox',
                    value: false
                });
            }
            return blockConfig;
        },
        description: (defaultDesign) => TypeConfigV2._addLineOptions(Content.TypeConfig.labelValue.panelV2.description(defaultDesign)),
        label: (defaultDesign) => TypeConfigV2._addLineOptions(Content.TypeConfig.labelValue.panelV2.label(defaultDesign || Utilities.wrapTextForEditor({ text: 'Signature:' }))),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (defaultDesign) => TypeConfigV2._addLineOptions(Content.TypeConfig.labelValue.panelV2.value(defaultDesign || Utilities.wrapTextForEditor({ text: 'Date:' })))
    },
    processLineOptions: (config, displayType) => {
        let label = '';
        let labelStyle = '';
        if (config.design != undefined) {
            if (config.labelSpacing && config.labelSpacing.value && config.labelSpacing.value.length > 0) {
                labelStyle += `${displayType == 'rows' || config.extendLine == true ? 'padding-bottom' : 'padding-right'}:${config.labelSpacing.value}${config.labelSpacing.unit};`
            }
            if (config.extendLine == true) {
                label = config.design || '&nbsp;';
            } else {
                label = `<td><div style="display:inline-block;white-space:nowrap;${labelStyle}">${config.design || '&nbsp;'}</div></td>`
            }
        }
        let borderWidth = '1px';
        if (config.lineWidth && config.lineWidth.value && config.lineWidth.value.length > 0) {
            borderWidth = `${config.lineWidth.value}${config.lineWidth.unit}`;
        }
        let style = `border-bottom-style:solid;border-bottom-width:${borderWidth};display:inline-block;width:100%;`
        if (config.lineColor) {
            style += `border-bottom-color:${config.lineColor};`
        }
        let content;
        if (config.extendLine == true) {
            content = `<td style="width:100%"><div style="${style}${labelStyle}">${label}</div></td>`;
        } else {
            content = `${label}<td style="width:100%"><div style="${style}">&nbsp;</div></td>`;
        }
        return `<table border="0" cellpadding="0" cellspacing="0" style="width:100%;"><tbody><tr>${content}</tr></tbody></table>`
    }
}

// #endregion V2

module.exports = {
    V1: {
        Component: SignatureV1,
        TypeConfig: TypeConfigV1
    },
    V2: {
        Component: SignatureV2,
        TypeConfig: TypeConfigV2
    }
};